/*
    创建者：shuxiaokai
    创建时间：2019-12-24 16:01
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div class="c-wrapper">
        <!-- 顶部 -->
        <s-header class="header"></s-header>
        <div class="content d-flex">
            <!-- 画布 -->
            <div class="viewport-wrap">
                <s-viewport></s-viewport>                
            </div>
            <!-- 配置中心 -->
            <s-config-pane></s-config-pane>
        </div>
    </div>
</template>

<script>
import header from "./header/header"
import viewport from "./viewport/viewport"
import configPane from "./config/config"
export default {
    components: {
        "s-header": header,
        "s-viewport": viewport,
        "s-config-pane": configPane,
    },
    data() {
        return {

        };
    },
    created() {
    },
    methods: {
        
    }
};
</script>



<style lang="scss">
.c-wrapper {
    &>.content {
        width: 100%;
        height: calc(100vh - 50px);            
        .viewport-wrap {
            height: 100%;
            min-width: 1200px;
            flex: 1;
        }
    }
}
</style>
